import { createSignal } from "solid-js";
import RnrUserDataCollectionModal from "~/components/webstore_telescope/user_data_collection_modal";
import { closeAllModals, openModalV2 } from "~/shared_states/modal";

export default function useUserInfoModal() {
  const [showLoader, setShowLoader] = createSignal<boolean>(false);
  const [errors, setErrors] = createSignal<{ [key: string]: string }>({});

  const openModal = (props: {
    clientLogoUrl?: string;
    brandDetails?: any;
    email: string | null;
    phone: string | null;
    name: string | null;
    onClickSubmit: (profileUpdateParams: any) => void;
    subtitle: string;
    collectPhone?: boolean;
    collectName?: boolean;
  }) => {
    openModalV2(() => {
      return (
        <RnrUserDataCollectionModal
          clientLogoUrl={props.clientLogoUrl}
          brandDetails={props.brandDetails}
          email={props.email}
          phone={props.phone}
          name={props.name}
          onClickSubmit={props.onClickSubmit}
          subtitle={props.subtitle}
          setShowLoader={setShowLoader}
          showLoader={showLoader}
          errors={errors}
          setErrors={setErrors}
          collectPhone={props.collectPhone}
          collectName={props.collectName}
        />
      );
    });
  };

  async function closeModal() {
    await closeAllModals();
    setShowLoader(false);
    setErrors({});
  }

  return {
    openModal,
    showLoader,
    setShowLoader,
    closeModal,
  };
}
